import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	src: string;
	alt?: string;
}

const Image: React.FC<Props> = ({ src, alt }) => {
	const { t } = useTranslation();
	return <img src={src} alt={alt || t('base.imagePlaceholder')} />;
};

export default Image;
